<script setup>
  import { onMounted, watch } from "vue";
  import { storeToRefs } from "pinia";
  import { useRoute } from "vue-router";
  import { useReportsV2Store } from "@stores/survey/reportsV2/reportsV2";

  const route = useRoute();

  const reportsStore = useReportsV2Store();
  const { currentReport } = storeToRefs(reportsStore);

  onMounted(async () => {
    // Fetch report if not already loaded or if token changed
    if (!currentReport.value || currentReport.value.token !== route.params.reportToken) {
      await reportsStore.fetchReport(route.params.reportToken);
    }
  });

  // Watch for route changes to reload report if needed
  watch(
    () => route.params.reportToken,
    async (newToken) => {
      if (newToken && (!currentReport.value || currentReport.value.token !== newToken)) {
        await reportsStore.fetchReport(newToken);
      }
    },
  );
</script>

<template>
  <router-view />
</template>
